import React from 'react';
import { useSelector } from 'react-redux';
import { smilingFace } from '../../../../../../shared/assets/emojis'
import { greeting } from '../../../../../../shared/utils/helpers/hosmanVars';

import SaleSteps from './components/SaleSteps';
import SalePropertySummary from './components/SalePropertySummary';
import CallToActions from './components/CallToActions';
import SaleKeyNumbers from './components/SaleKeyNumbers';
import Marketing from './components/Marketing';

import { LoadingLayer, FadeIn, Emoji, Separator } from 'hosman-material';

const Sale = () => {
  const { user } = useSelector((state) => state.user);
  const { requestState } = useSelector((state) => state.sellerSales);

  return (
    <div data-testid='Sale'>
      <LoadingLayer isReady={requestState == 'done'}>
        <FadeIn>
          <p className='h2 mb-8 text-ih-indigo text-center md:text-left'>Bonjour {greeting(user)}<span className='ml-2'><Emoji emojiSrc={smilingFace} width='w-7' /></span></p>

          <CallToActions />

          <SaleSteps />

          <SaleKeyNumbers />

          <Separator />

          <SalePropertySummary />

          <Marketing />
        </FadeIn>
      </LoadingLayer>
    </div>
  );
}

export default Sale;
